import LocalStorage from "./LocalStorage";

export const getAuthToken = () => {
  return LocalStorage.getItem("authToken");
};

export const isUserAuthenticated = () => {
  return !!getAuthToken();
};

export const getHighlightsFromLocalStorage = () => {
  const storedHighlights = localStorage.getItem("highlights");
  return storedHighlights ? JSON.parse(storedHighlights) : [];
};

export const setHighlightsToLocalStorage = (highlights) => {
  localStorage.setItem("highlights", JSON.stringify(highlights));
};

const HIGHLIGHT_STEPPER_STORAGE_KEY = "highlightStepperState";

export const getHighlightStepperState = () => {
  try {
    const stored = localStorage.getItem(HIGHLIGHT_STEPPER_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const setHighlightStepperState = (state) => {
  if (state == null) {
    localStorage.removeItem(HIGHLIGHT_STEPPER_STORAGE_KEY);
  } else {
    localStorage.setItem(HIGHLIGHT_STEPPER_STORAGE_KEY, JSON.stringify(state));
  }
};
